import { render } from "./Frist.vue?vue&type=template&id=b7780e1e&scoped=true"
import script from "./Frist.vue?vue&type=script&lang=js"
export * from "./Frist.vue?vue&type=script&lang=js"

import "./Frist.vue?vue&type=style&index=0&id=b7780e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7780e1e"]])

export default __exports__